import { render, staticRenderFns } from "./studio-equipment.vue?vue&type=template&id=1ad96adc&"
import script from "./studio-equipment.vue?vue&type=script&lang=js&"
export * from "./studio-equipment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports